import { NestedTreeControl } from "@angular/cdk/tree";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatTreeNestedDataSource } from "@angular/material/tree";

import { BrandCampaign } from "../../../../shared/models/brandCampaign";
import {
  IGoogleAudience,
  IGoogleAudienceData,
} from "../../shared/services/google-targeting.service";

@Component({
  selector: "app-brand-campaign-google-targeting-picker",
  templateUrl: "./brand-campaign-google-targeting-picker.component.html",
  styleUrl: "./brand-campaign-google-targeting-picker.component.scss",
})
export class BrandCampaignGoogleTargetingPickerComponent implements OnInit {
  @Input({ required: true }) public campaign!: BrandCampaign;
  @Input({ required: true })
  public googleTargetingOptions!: IGoogleAudienceData;

  @Output() public googleTargetingUpdated = new EventEmitter<void>();

  protected readonly dataSource =
    new MatTreeNestedDataSource<IGoogleAudience>();
  protected readonly treeControl = new NestedTreeControl<IGoogleAudience>(
    (node) => node.children,
  );

  private flattenGoogleTargetingOptions!: IGoogleAudience[];

  public ngOnInit(): void {
    this.dataSource.data = this.googleTargetingOptions.tree;
    this.flattenGoogleTargetingOptions = this.googleTargetingOptions.flat;
  }

  protected hasChild(_: number, node: IGoogleAudience): boolean {
    return (node.children && node.children.length > 0) ?? false;
  }

  protected toggleCheckbox(node: IGoogleAudience): void {
    if (this.isChecked(node.audienceId)) {
      let index = 0;

      do {
        index = this.campaign.googleAdsAudienceIds.indexOf(node.audienceId);
        if (index > -1) {
          this.campaign.googleAdsAudienceIds.splice(index, 1);
        }
      } while (index > -1);

      this.unCheckNodeChildren(node);
    } else {
      this.campaign.googleAdsAudienceIds.push(node.audienceId);
      this.checkNodeChildren(node);
      this.checkNodeParent(node);
    }

    this.googleTargetingUpdated.emit();
  }

  private checkNodeParent(node: IGoogleAudience): void {
    if (!node.parentId) {
      return;
    }

    if (!this.isChecked(node.parentId)) {
      this.campaign.googleAdsAudienceIds.push(node.parentId);
    }

    const parent = this.findParent(node.parentId);

    if (parent) {
      this.checkNodeParent(parent);
    }
  }

  private findParent(parentId: number): IGoogleAudience | undefined {
    return this.flattenGoogleTargetingOptions.find(
      (node) => node.audienceId === parentId,
    );
  }

  private unCheckNodeChildren(node: IGoogleAudience): void {
    node.children?.forEach((child) => {
      const index = this.campaign.googleAdsAudienceIds.indexOf(
        child.audienceId,
      );

      if (index > -1) {
        this.campaign.googleAdsAudienceIds.splice(index, 1);
        this.unCheckNodeChildren(child);
      }
    });
  }

  private checkNodeChildren(node: IGoogleAudience): void {
    node.children?.forEach((child) => {
      if (!this.isChecked(child.audienceId)) {
        this.campaign.googleAdsAudienceIds.push(child.audienceId);
      }

      this.checkNodeChildren(child);
    });
  }

  protected isChecked(audienceId: number): boolean {
    return this.campaign.googleAdsAudienceIds.includes(audienceId);
  }
}
